import * as ObservationConstants from '@/lib/observation-constants'
import store from '@/store'
import i18n from '@/lib/i18n'
import UserInfo from '@/lib/user-info'

export default class ObservationInfo {
  constructor(observation, type) {
    this.type = type
    this.observation = observation
  }

  get field() {
    if (this.observation.placeType === 'Field') {
      let id = this.observation.placeId
      if (UserInfo.isFSMigrated()) {
        id = this.observation.fireFieldId
      }
      let f = store.getters.fields.filter(f => f.id === id)
      if (f.length > 0) {
        return f[0]
      }
    }
    return { name: i18n.tt('observation.deletedField'), deleted: true }
  }

  get weatherModel() {
    if (this.type === ObservationConstants.TYPE_SOLID_MOISTURE) {
      for (const pf of store.getters.growSoilMoistures) {
        if (pf.observationId === this.observation.id) {
          return pf
        }
      }
      return { roundedPf: '??' }
    }

    if (this.type === ObservationConstants.TYPE_ACCUMULATED_TEMPERATURE) {
      for (const at of store.getters.growAccumulatedTemperatures) {
        if (at.observationId === this.observation.id) {
          return at
        }
      }
      return { roundedTemperature: '??' }
    }
  }

  get weatherModelFromOpenMeteo() {
    if (this.type === ObservationConstants.TYPE_SOLID_MOISTURE) {
      for (const pf of store.getters.growSoilMoisturesFromOpenMeteo) {
        if (pf.observationId === this.observation.id) {
          return pf
        }
      }
      return null
    }

    if (this.type === ObservationConstants.TYPE_ACCUMULATED_TEMPERATURE) {
      for (const at of store.getters.growAtFromOpenMeteo) {
        if (at.observationId === this.observation.id) {
          return at
        }
      }
      return { roundedTemperature: '??' }
    }
  }
}
